export default function SubscriptionTabs({
  license,
  isYear,
  changeSubscriptionDuration,
}) {
  return (
    license === "Premium" && (
      <div className="flex flex-row w-[90%] h-9 p-1  bg-white rounded-md text-primaryBlue font-semibold cursor-pointer mt-2 tall:mt-3">
        <div
          onClick={() => changeSubscriptionDuration(false)}
          className={`flex w-full h-full justify-center items-center rounded-md ${
            !isYear
              ? "shadow-md border-[1px] border-opacity-30 border-lightGrey"
              : "text-lightGrey"
          }`}
        >
          Måned
        </div>
        <div
          onClick={() => changeSubscriptionDuration(true)}
          className={`flex w-full h-full justify-center items-center rounded-md ${
            isYear
              ? "shadow-md border-[1px] border-opacity-30 border-lightGrey"
              : "text-lightGrey"
          }`}
        >
          Ar
        </div>
      </div>
    )
  );
}
